'use client';

import { cn } from '@/utils/cn';

interface NewsTileProps {
    tag: string;
    title: string;
    children: string;
}

export default function NewsTile({ tag, title, children }: NewsTileProps) {
    return (
        <div
            className={cn(
                'news-tile',
                'relative',
                'bg-haug-coral-100 text-haug-ivory-30',
                'p-4 pt-14',
                'font-neue-haas'
            )}
        >
            <div className="absolute top-0 left-0 bg-haug-coral-70 px-2 py-1 font-bold text-base uppercase">
                {tag}
            </div>
            <h2 className="font-bold text-4xl">{title}</h2>
            <div
                className="rich-text py-4 text-base"
                dangerouslySetInnerHTML={{ __html: children }}
            ></div>
        </div>
    );
}
